const newsList = document.querySelector('.news-list');

if (newsList) {
  const urlParams = ['years', 'locations', 'pageNumber'];

  const getExtraFormDataInput = (parent) => ({
    moduleIndex: parent.querySelector('[data-k]').value,
    allYearMonthPair: parent.querySelector('[data-all-year-month-pair]').value,
    nextMonthStartIndex: parent.querySelector('[data-next-month-start-index]').value || 0,
    years: getCheckedData(parent, 'years'),
    locations: getCheckedData(parent, 'locations'),
    id: localData.id,
  });

  // Filter click
  attachEvent('.news-list .mod-filter .dropdown__list-item input', 'click', (ev) => {
    const parent = ev.target.closest('.news-list');
    const dataPageNumber = parent.querySelector('[data-page-number]');
    if (dataPageNumber) {
      dataPageNumber.setAttribute('data-page-number', 1);
    }

    axiosGetPaginateAndFilteredPosts(parent, 1, urlParams, getExtraFormDataInput(parent));
  });

  // Pagination
  attachEvent('.news-list .news-list__load-more', 'click', (ev) => {
    const parent = ev.target.closest('.news-list');
    const dataPageNumber = ev.target.closest('[data-page-number]');
    const currentPage = parseInt(dataPageNumber?.getAttribute('data-page-number'), 10) || 1;
    const nextPage = currentPage + 1;
    dataPageNumber.setAttribute('data-page-number', nextPage);

    axiosGetPaginateAndFilteredPosts(parent, nextPage, urlParams, getExtraFormDataInput(parent), false);
  });
}
